var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.options),function(option,ok){return _c('div',{key:ok,staticClass:"col-6 col-md-4 my-2 my-lg-4 box"},[_c('img',{class:{
                'img-fluid': true,
                'selected': option == _vm.internalValue,
                'not-selected': option != _vm.internalValue
            },attrs:{"src":'/assets/img/avatars/class/' + option + '.svg'},on:{"click":function($event){_vm.internalValue = option}}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }